<template>
  <div>
    <h1 class="text-lg font-medium text-gray-800 md:text-lg">
      Breakdown by Scope
    </h1>
    <div class="w-full p-6 mt-5 bg-white border border-transparent rounded-md shadow-sm hover:drop-shadow-sm border-slate-200">
      <apex-chart
        ref="scopesChartGraph"
        height="450"
        :options="scopesChartOptions"
        :series="scopesChartSeries"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScopesChartGraph',

  props: {
    chartSeries: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      scopesChartSeries: this.chartSeries,
      scopesChartOptions: {
        grid: {
          show: false,
        },
        chart: {
          toolbar: {
            show: false,
          },
          type: 'area',
          height: '450px',
          stacked: true,
        },
        colors: ['#008FFB', '#00E396', '#064C72'],
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
        },
        stroke: {
          curve: 'straight',
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        fill: {
          type: 'solid',
          opacity: 0.5,
        },
        xaxis: {
          title: {
            text: 'Current Reporting Year',
          },
          categories: this.labels,
        },
        yaxis: {
          title: {
            text: 'tCO2e',
          },
          labels: {
            show: true,
            formatter(val) {
              return thousands(val, 2, true)
            },
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${thousands(val, 0)} tCO2e`
            },
          },
        },
      },
    }
  },

  watch: {
    chartSeries(newSeries) {
      this.scopesChartSeries = newSeries
    },
    labels(newLabels) {
      this.scopesChartOptions.xaxis.categories = newLabels
      this.$refs.scopesChartGraph.updateOptions(this.scopesChartOptions)
    },
  },
}
</script>
